// TODO: In progress
const SubscriptionCheckoutSuccess = () => {
  return <div> Success</div>
}

export default SubscriptionCheckoutSuccess
